module.exports = __webpack_public_path__ + "static/monitor-sm-e695b83f6c721e6d700799f5a5a8e73c.png";